import { render, staticRenderFns } from "./TableColumnEditModal.vue?vue&type=template&id=40bc90fa&scoped=true&"
import script from "./TableColumnEditModal.vue?vue&type=script&lang=ts&"
export * from "./TableColumnEditModal.vue?vue&type=script&lang=ts&"
import style0 from "./TableColumnEditModal.vue?vue&type=style&index=0&id=40bc90fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bc90fa",
  null
  
)

export default component.exports